export default __webpack_public_path__ + "static/media/qr.fc9e828b.svg";